import React from 'react';

import SubscribeIcon from '../../icons/SubscribeIcon';

const colors = require('common/lib/colors/colors.less');
import IconButton from './IconButton';

const SubscribeButton = (props) => (
  <IconButton {...props} icon={<SubscribeIcon color={colors.N100} />}>
    Subscribe
  </IconButton>
);

export default SubscribeButton;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/buttons/SubscribeButton.js